import { Player } from '@lottiefiles/react-lottie-player';
import { AnimationItem } from 'lottie-web';
import * as React from 'react';
import styled from 'styled-components';

import * as animationData from './option_audio_srkhpjcv.json';

// because of svg blurry happen on safari/mac, I've to put the spell "svg transforms: unset !important"
const Main = styled.div`
  line-height: 0;
  svg {
    width: 1em !important;
    height: 1em !important;
    transform: unset !important;
    fill: currentColor;

    path {
      fill: currentColor;
      stroke: currentColor;
    }
  }
`;

export interface OptionAudioAnimateProps {
  isPlaying: boolean;
}

const LAST_FRAME = 50;

export const OptionAudioAnimate = ({ isPlaying }: OptionAudioAnimateProps) => {
  const ref = React.useRef<AnimationItem>();

  React.useEffect(() => {
    if (!ref.current) return;
    if (isPlaying) {
      ref.current.goToAndPlay(0, true);
    } else {
      ref.current.goToAndStop(LAST_FRAME, true);
    }
  }, [isPlaying]);
  return (
    <Main className="option-audio-animate">
      <Player
        renderer="svg"
        lottieRef={(lottieRef) => {
          ref.current = lottieRef;
          // to display last frame on mount
          ref.current.goToAndStop(LAST_FRAME, true);
        }}
        loop
        src={animationData}
      />
    </Main>
  );
};
